import { render, staticRenderFns } from "./EditLandingThings.vue?vue&type=template&id=e021c042&scoped=true"
import script from "./EditLandingThings.vue?vue&type=script&lang=js"
export * from "./EditLandingThings.vue?vue&type=script&lang=js"
import style0 from "./EditLandingThings.vue?vue&type=style&index=0&id=e021c042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e021c042",
  null
  
)

export default component.exports